import { createClient } from "@connectrpc/connect";
import { grpcTransportProvider } from "../../../../comun/services/grpc/GrpcTransport";
import { PasswordResetService } from "../../../../generated/grpc/password_reset_pb";
import { secureStorage } from "../../login/services/SecureStorageService";
import { RestablecerPasswordRequest } from "../request/RestablecerPasswordRequest";
import { mapPasswordResetGrpcError } from "./mapPasswordResetGrpcError";

/** Cambia la contraseña con el `resetToken` del paso 2 (`PasswordResetService.Restablecer`,
 *  gRPC-Web). Al éxito deja la sesión local limpia — el backend invalidó todas
 *  las sesiones del usuario, así que el token guardado ya no sirve. */
class RestablecerPasswordGrpcService {
  async restablecerAsync(request: RestablecerPasswordRequest): Promise<void> {
    const client = createClient(PasswordResetService, grpcTransportProvider.get());
    try {
      await client.restablecer({
        resetToken: request.resetToken,
        password: request.password,
      });
    } catch (error) {
      throw mapPasswordResetGrpcError(error);
    }

    await secureStorage.remove();
    grpcTransportProvider.clearToken();
  }
}

/** Singleton del servicio del paso 3, variante gRPC (sin estado). */
export const restablecerPasswordGrpcService = new RestablecerPasswordGrpcService();
